import { FC, useCallback } from "react";
import { MDSIconButton } from "@/mds";
import { MdsIconKind } from "@/design-system/components/icon";
import { electronModule } from "@/modules/electron";

interface DesktopMenuButtonProps {
  className?: string;
}

export const DesktopMenuButton: FC<DesktopMenuButtonProps> = ({ className }) => {
  const onClick = useCallback(() => {
    electronModule.toggleMenu();
  }, []);

  return (
    <MDSIconButton
      className={className}
      aria-label="Open menu"
      iconKind={MdsIconKind.Menu}
      onClick={onClick}
    />
  );
};
